/**
 * * Отписка от очередностей пользователей
 */
export default class UnSubscribeToOrderTaskListRequestModel {
  /**
   * * Список пользователей для отписки
   */
  UserIds!: Array<number>;
  constructor(obj?: Partial<UnSubscribeToOrderTaskListRequestModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
